<template lang="pug">
  v-container
    v-row
      v-col
        v-card.text-center
          v-card-title.justify-center Progression
          v-card-text.text-h2
            strong {{ progress }}
            | %
          v-card-actions.body-1.justify-center {{ viewsCountTotal - viewsCountRemaining }} / {{ viewsCountTotal }} visionnages
    v-row
      v-col
        v-list
          v-list-item
            v-list-item-content
              v-list-item-title Moyenne des avis
            v-list-item-action
              v-list-item-action-text.body-1
                strong {{ ratingAverage / 2 }}
                |  / 5
          v-list-item
            v-list-item-content
              v-list-item-title Nombre d'avis
            v-list-item-action
              v-list-item-action-text.body-1
                strong {{ ratingCount }}
          v-list-item
            v-list-item-content
              v-list-item-title nombre de clics sur votre lien
            v-list-item-action
              v-list-item-action-text.body-1
                strong {{ viewsCountLink }}
          v-list-item
            v-list-item-content
              v-list-item-title nombre de clics sur votre profil
            v-list-item-action
              v-list-item-action-text.body-1
                strong {{ viewsCountLink }}
</template>

<script>
import { page } from '@iez/core'
import data from '@iez/lib/data/'
import { computed } from '@vue/composition-api'
import { routeCurrent } from '@iez/core/router/'

const route = {
  path: `/my-ads/:id`,
  name: `MyAds_id`
}

export default {
  ...route,

  setup () {
    const ad = data.get({
      root: `ads`,
      one: true,
      request: {
        where: {
          id: {
            _eq: routeCurrent.params.id
          }
        }
      },
      fields: [
        `id`,
        `viewsCountTotal`,
        `countLink`,
        //`countVisit`,
        `viewsCountRemaining`
      ]
    })

    const viewsAdsWithRating = data.get({
      root: `viewsAds`,
      request: {
        where: {
          _and: {
            adId: {
              _eq: routeCurrent.params.id
            },
            rating: {
              _is_null: false
            }
            /*countLink: {
              _is_null: false
            }*/
          }
        }
      },
      fields: [
        `id`,
        `rating`
      ]
    })

    const viewsCountTotal = computed(
      () => ad.value?.viewsCountTotal
    )

    const viewsCountRemaining = computed(
      () => ad.value?.viewsCountRemaining
    )

    const progress = computed(
      () => Math.floor(((viewsCountTotal.value - viewsCountRemaining.value) * 100) / viewsCountTotal.value * 100) / 100
    )

    const ratingAverage = computed(
      () => (
        viewsAdsWithRating.value?.reduce(
          (accumulator, currentValue) =>
            accumulator + currentValue.rating,
          0
        ) / ratingCount.value
      ).toFixed(2)
    )

    const ratingCount = computed(
      () => viewsAdsWithRating.value?.length
    )

    const viewsCountLink = computed(
      () => ad.value?.countLink
    )

    /*const viewsCountVisit = computed(
      () => ad.value?.countVisit
    )*/


    page.topBar.set(
      () => ({
        title: `Nom campagne 1`
      })
    )

    return {
      viewsCountTotal,
      viewsCountRemaining,
      viewsCountLink,
      //viewsCountVisit,
      progress,
      ratingAverage,
      ratingCount
    }
  }
}
</script>
